import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthSession } from './AuthSessionContext';
import { 
  Box,
  Typography,
  Paper,
} from '@mui/material';



function NoAuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, roles: userRoles, loading } = useAuthSession();
  const isAuthenticated = Boolean(user);
  const searchParams = new URLSearchParams(location.search);
  const isForbiddenRedirect = searchParams.get('reason') === 'forbidden';
  
  useEffect(() => {
    if (!loading && !isAuthenticated) {
      navigate('/login');
      return;
    }

    if (!loading && isAuthenticated && !isForbiddenRedirect) {
      if (userRoles.includes('reader')) {
        navigate('/dashboard', { replace: true });
        return;
      }

      if (userRoles.includes('reviewer') || userRoles.includes('admin') || userRoles.includes('uploader')) {
        navigate('/', { replace: true });
      }
    }
  }, [isAuthenticated, isForbiddenRedirect, loading, navigate, userRoles]);

  if (!isAuthenticated) {
    return null;
  }

  if (!isForbiddenRedirect) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="40vh" bgcolor="#f5f5f5">
      <Paper elevation={2} style={{ padding: '40px', maxWidth: '400px', width: '100%' }}>
        <Typography variant="h5" component="h1" style={{ color: '#c62828', marginBottom: '12px' }}>
          Page not available
        </Typography>
        <Typography variant="body1">
          You do not have access to this page or resource. If you think this is wrong, contact an administrator.
        </Typography>
      </Paper>
    </Box>
  );
}

export default NoAuthPage;
